import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
	faBars,
	faCalendarDays,
	faChevronDown,
	faEnvelope,
	faGift,
	faPhone,
	faChevronUp,
	faGlobe,
	faCroissant,
	faSuitcase,
	faPeople,
	faTimes,
} from '@fortawesome/pro-light-svg-icons';

import {
	faFacebook,
	faInstagram,
	faLinkedin,
	faPinterest,
	faSoundcloud,
	faSpotify,
	faTiktok,
	faTwitter,
	faWhatsapp,
	faYoutube,
} from '@fortawesome/free-brands-svg-icons';

import {
	faArrows,
	faBedAlt,
	faBellConcierge,
	faCheck,
	faChevronDown as faChevronDownSolid,
	faEuroSign,
	faMinus,
	faPlay,
	faPlus,
	faRulerCombined,
	faSearch,
	faStar,
	faStars,
	faQuoteLeft,
	faStarHalf,
	faUsers,
	faXmark,
} from '@fortawesome/pro-solid-svg-icons';

// This is important, we are going to let Nuxt.js worry about the CSS
config.autoAddCss = false;

library.add(
	faArrows,
	faBars,
	faBedAlt,
	faBellConcierge,
	faCroissant,
	faGift,
	faSuitcase,
	faPeople,
	faCheck,
	faChevronUp,
	faChevronDown,
	faChevronDownSolid,
	faCalendarDays,
	faEnvelope,
	faEuroSign,
	faTimes,
	faGlobe,
	faQuoteLeft,
	faFacebook,
	faInstagram,
	faLinkedin,
	faMinus,
	faPinterest,
	faPhone,
	faPlay,
	faPlus,
	faRulerCombined,
	faSearch,
	faSoundcloud,
	faSpotify,
	faStars,
	faTiktok,
	faTwitter,
	faUsers,
	faWhatsapp,
	faYoutube,
	faStar,
	faStarHalf,
	faXmark,
);

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.component('font-awesome-icon', FontAwesomeIcon, {});
});
